<main>
    <div>
        <h1>Digital Image Archive</h1>
        <hr>
        <p>Enterprise service for storage of images within Postnord. It is also fully in-line with a digitalization
            strategy, where PostNord maintains a “digital replica” of the items serviced and means of transport that is
            being utilized.
        </p>
    </div>
    <div
        class="swiper swiper-coverflow swiper-3d swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress">
        <div class="swiper-wrapper" id="swiper-wrapper-c0b09bbdab103f556" aria-live="polite"
            style="cursor: grab; transition-duration: 0ms; transform: translate3d(-881.25px, 0px, 0px);">
            <!-- <div class="swiper-slide swiper-slide--four swiper-slide-duplicate" data-swiper-slide-index="3" role="group"
                aria-label="4 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -900px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -8;">

                <div class="swiper-slide-shadow-left" style="opacity: 9; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 0; transition-duration: 0ms;"></div>
            </div>
            <div class="swiper-slide swiper-slide--five swiper-slide-duplicate" data-swiper-slide-index="4" role="group"
                aria-label="5 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -599.574px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -5;">

                <div class="swiper-slide-shadow-left" style="opacity: 5.99574; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 0; transition-duration: 0ms;"></div>
            </div> -->
            <div class="swiper-slide swiper-slide--one swiper-slide-visible swiper-slide-prev"
                data-swiper-slide-index="0" role="group" aria-label="1 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -300px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -2;">

                <div class="swiper-slide-shadow-left" style="opacity: 3; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 0; transition-duration: 0ms;"></div>
            </div>
            <div class="swiper-slide swiper-slide--two swiper-slide-visible swiper-slide-active"
                data-swiper-slide-index="1" role="group" aria-label="2 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -0.425532px) rotateX(0deg) rotateY(0deg) scale(1); z-index: 1;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 0.00425532; transition-duration: 0ms;"></div>
            </div>

            <div class="swiper-slide swiper-slide--three swiper-slide-visible swiper-slide-next"
                data-swiper-slide-index="2" role="group" aria-label="3 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -300px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -2;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 3; transition-duration: 0ms;"></div>
            </div>

            <div class="swiper-slide swiper-slide--four" data-swiper-slide-index="3" role="group" aria-label="4 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -600.426px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -5;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 6.00426; transition-duration: 0ms;"></div>
            </div>

            <div class="swiper-slide swiper-slide--five" data-swiper-slide-index="4" role="group" aria-label="5 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -900px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -8;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 9; transition-duration: 0ms;"></div>
            </div>
            <!-- <div class="swiper-slide swiper-slide--one swiper-slide-duplicate swiper-slide-duplicate-prev"
                data-swiper-slide-index="0" role="group" aria-label="1 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -1200.43px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -11;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 12.0043; transition-duration: 0ms;"></div>
            </div>
            <div class="swiper-slide swiper-slide--two swiper-slide-duplicate swiper-slide-duplicate-active"
                data-swiper-slide-index="1" role="group" aria-label="2 / 5"
                style="width: 352.5px; transition-duration: 0ms; transform: translate3d(0px, 0px, -1500px) rotateX(0deg) rotateY(0deg) scale(1); z-index: -14;">

                <div class="swiper-slide-shadow-left" style="opacity: 0; transition-duration: 0ms;"></div>
                <div class="swiper-slide-shadow-right" style="opacity: 15; transition-duration: 0ms;"></div>
            </div> -->
        </div>
        <!-- Add Pagination -->
        <div
            class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
            <span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 1"></span><span
                class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button"
                aria-label="Go to slide 2" aria-current="true"></span><span class="swiper-pagination-bullet"
                tabindex="0" role="button" aria-label="Go to slide 3"></span><span class="swiper-pagination-bullet"
                tabindex="0" role="button" aria-label="Go to slide 4"></span><span class="swiper-pagination-bullet"
                tabindex="0" role="button" aria-label="Go to slide 5"></span>
        </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
    </div>
    <img src="../../../../assets/images/pn-1.jpg" alt="" class="bg">
    <div class="bg2"></div>
</main>